import { MenuItem } from './custom-menu-item.styles'
import { ICustomMenuItemProps } from './custom-menu-item.types'

export const CustomMenuItem = (props: ICustomMenuItemProps) => {
  const { children, onClick, isActive, height, isDisabled } = props

  return (
    <MenuItem
      className={'close'}
      onClick={onClick}
      isActive={isActive}
      height={height}
      disabled={isDisabled}
    >
      {children}
    </MenuItem>
  )
}
